import React, {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import BlogImagePopper from "./BlogImageLarge";
import image1 from "../../../../assets/images/Blog57/image1.png";
import image6 from "../../../../assets/images/Blog57/image6.png";
import image2 from "../../../../assets/images/Blog57/image2.png";
import image20 from "../../../../assets/images/Blog57/image20.png";
import image21 from "../../../../assets/images/Blog57/image21.png";
import image9 from "../../../../assets/images/Blog57/image9.png";
import image10 from "../../../../assets/images/Blog57/image10.png";
import image11 from "../../../../assets/images/Blog57/image11.png";
import image16 from "../../../../assets/images/Blog57/image16.png";
import image17 from "../../../../assets/images/Blog57/image17.png";
import image18 from "../../../../assets/images/Blog57/image18.png";
import image24 from "../../../../assets/images/Blog57/image24.png";
import image25 from "../../../../assets/images/Blog57/image25.png";
import image22 from "../../../../assets/images/Blog57/image22.png";
import image4 from "../../../../assets/images/Blog57/image4.png";
import image38 from "../../../../assets/images/Blog57/image38.png";
import image55 from "../../../../assets/images/Blog57/image55.png";
import image78 from "../../../../assets/images/Blog57/image78.png";
import image80 from "../../../../assets/images/Blog57/image80.png";
import image83 from "../../../../assets/images/Blog57/image83.png";
import image85 from "../../../../assets/images/Blog57/image85.png";
import image86 from "../../../../assets/images/Blog57/image86 US data and speakers.png";
import image79 from "../../../../assets/images/Blog57/image79.png";

const Blog57 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – February 23, 2026</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedText">Grinding Through Uncertainty, Liquidity Cross-Currents and Rotation Define the Tape</p>
        <p>
          Markets move into the latter part of February with price action continuing to grind higher despite persistent concerns about downside risks. The environment reflects a classic “wall of
          worry,” where institutional long buying and retail participation coexist with speculative flows leaning the other way, creating conditions where weaker positioning can be squeezed as markets
          advance.
        </p>
        <p>
          Liquidity remains a key driver beneath the surface. Funding needs in the bond market, ongoing geopolitical developments, and major earnings catalysts are shaping short-term flows, while
          sector rotation — particularly across technology, commodities, and defensives — highlights an environment where the broader structure remains intact even as underlying dynamics evolve.
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: Constructive Structure with Ongoing Rotation</p>

              <p>
                Equity markets continue to show resilience, with participation broad enough to support the advance even as leadership rotates across sectors. Price action suggests that markets are
                absorbing headline risks, including policy developments and geopolitical noise, without losing structural footing.
              </p>
              <p>
                Institutional buying alongside retail activity has created a backdrop where short positioning risks being squeezed, reinforcing the constructive tone. At the same time, there is
                evidence of defensive flows emerging as seasonal tendencies and macro uncertainties encourage a degree of caution.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image1}
                    alt="breadth of SPX performance"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image1)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Rotation within the AI ecosystem remains a defining theme. While enthusiasm around artificial intelligence persists, flows are increasingly differentiating between areas seen as
                structural beneficiaries — such as semiconductors, infrastructure, and energy inputs — and segments facing questions around long-term disruption.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image6}
                    alt="semis over software divergence"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image6)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                NVIDIA sits at the centre of this dynamic, with expectations around earnings and guidance acting as a key catalyst not just for the stock but for broader market sentiment and
                dispersion across large-cap technology.
              </p>
              <div className="relatedImg">
                <img
                  src={image2}
                  alt=" NVDA stuck in narrow range"
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image2)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <p>
                Global equity benchmarks continue to reflect strength, with new highs in broad indices reinforcing the idea that the overall structure remains constructive despite tactical volatility.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image20}
                    alt="NYA all stocks ATH"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image20)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image21}
                    alt="Stoxx600 europe ATH"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image21)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Liquidity Drains, Policy Signals, and Mixed Data</p>
              <p>
                Policy developments around tariffs have reintroduced uncertainty, with legal rulings and alternative mechanisms shaping expectations around trade policy. The key issue is less the
                immediate outcome and more the potential for prolonged uncertainty to influence corporate planning and earnings outlooks.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image9}
                    alt="alternative Trump tariff rules"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image9)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Liquidity dynamics are particularly important this week, with significant funding needs tied to bond market settlements historically associated with softer equity sessions. These flows
                coincide with major earnings events, reinforcing the importance of monitoring cross-asset interactions.
              </p>
              <p>
                Economic data have presented a mixed picture. Surprise indices have turned negative, reflecting softer headline momentum, yet underlying components such as business investment measures
                suggest pockets of resilience beneath the surface.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image10}
                    alt="US data surprise slip"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image10)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image11}
                    alt="Durable goods core read strong"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image11)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Housing indicators and consumer sentiment point to uneven momentum, consistent with a gradual rather than synchronised expansion. Slippage in pending sales and permits alongside softer
                sentiment readings highlight areas of cooling without signalling broad deterioration.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image16}
                    alt="Pending home sales slip"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image16)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image17}
                    alt="building permits not improving"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image17)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image18}
                    alt="UoM sentiment slips back"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image18)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Geopolitical developments continue to influence commodities, with oil and gold responding to military posturing and supply dynamics, though historical patterns suggest such spikes
                often fade over time.
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Consolidation with Strong Internals</p>
              <p>
                Market internals remain supportive even as headline indices face challenges holding near-term moving averages. This combination — firm breadth alongside episodic momentum stalls —
                reflects a market advancing while continuously testing conviction.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image24}
                    alt="SPX500 internals are strong"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image24)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                The NASDAQ shows signs of testing momentum, with key moving averages acting as important reference points as investors assess whether recent consolidation represents a pause within an
                uptrend or a broader shift in leadership.
              </p>
              <div className="relatedImg">
                <img
                  src={image25}
                  alt="Nas100 weaker impulse and ma failures"
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image25)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <p>
                Sentiment indicators highlight elevated positioning around key catalysts, including options activity suggesting heightened focus on directional risk. At the same time, volatility
                measures imply that markets may be pricing less risk than recent price behaviour might suggest.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image22}
                    alt="SPX500 options on direction"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image22)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                Flows and positioning data point to confusion among investors, with surveys showing optimism on earnings alongside concerns around overinvestment and crowded trades. This mix
                reinforces the view that markets are navigating competing narratives rather than a single dominant theme.
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Liquidity Signals and Cross-Asset Adjustments</p>
              <p>
                Recent developments reflected a combination of earnings reactions, policy headlines, and evolving positioning across asset classes, reinforcing the theme of resilience alongside
                underlying caution.
              </p>
              <p className="highlightedText">Key Highlights:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span>
                    <br></br> Data releases showed softer surprise readings while underlying indicators suggested continued activity. Policy discussions and liquidity considerations remained central
                    to market interpretation as investors assessed the implications for growth and rates.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image10}
                        alt="US data surprise slip"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image10)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span>
                    <br></br>Developments around new AI initiatives and competitive dynamics within technology drew attention, highlighting potential shifts in global innovation and cost structures
                    that could influence sentiment.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image4}
                        alt="another deepseek moment on the way?"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image4)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings:</span>
                    <br></br> Corporate results broadly exceeded expectations, with a significant proportion of companies reporting above estimates and forward growth expectations remaining
                    constructive even as markets focused closely on guidance.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image38}
                        alt="Q4 2025 eps growth back on track"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image38)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Commodities: </span>
                    <br></br> Gold continued to show strength amid uncertainty and positioning dynamics, while broader commodity behaviour reflected geopolitical developments and supply
                    considerations, reinforcing the role of real assets within portfolio allocations.
                  </p>
                </li>
                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image55}
                      alt="record 8 weeks up for gold"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image55)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <div className="relatedImg">
                    <img
                      src={image78}
                      alt="metals still bid"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image78)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto:</span>
                    <br></br> Digital assets saw positioning adjustments and ongoing debate around flows, with market participants assessing whether recent moves represent consolidation within a
                    broader trend or continued volatility driven by sentiment shifts.
                  </p>
                </li>
                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image80}
                      alt=" have we seen the max drawdown in BTC?"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image80)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <div className="relatedImg">
                    <img
                      src={image83}
                      alt="healthy ETF drawdown and retention in BTC"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image83)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Oil:</span>
                    <br></br> Energy markets remained sensitive to geopolitical developments and inventory dynamics, with price action reflecting fluctuating risk premia and the interaction between
                    supply concerns and macro expectations.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image79}
                        alt="oil toying with channel breakout"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image79)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: Key Data and Market-Moving Signals</p>
              <p>
                The week is centred on NVIDIA earnings, which effectively act as the primary macro catalyst given their influence across AI, large-cap technology, and broader risk sentiment. Liquidity
                will remain an important theme as multiple bond auctions and settlement flows keep funding conditions in focus. The State of the Union address introduces potential policy headline
                risk, while PPI later in the week will be closely watched for signals on inflation pressures.
              </p>
              <p className="highlightedText">Monday, February 23</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText"> Global: </span>China Lunar New Year holiday (liquidity impact)
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText"> Germany:</span> Ifo business climate index and expectations
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText"> Italy:</span> CPI releases
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Chicago Fed national activity index
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Factory orders and durable goods data
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Dallas Fed manufacturing index
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">France:</span> Treasury bill auctions
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> 3-month and 6-month bill auctions
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText"> Central bank speakers: </span>Fed, ECB, BoE
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, February 24</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span> FDI data
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UK:</span> CBI distributive trades survey
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">US:</span> House price indices
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Consumer confidence
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Richmond Fed manufacturing index
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Wholesale inventories and trade sales
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Money supply data
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> API crude oil inventories
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> 2-year note auction
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> State of the Union address
                  </p>
                </li>
                <li className="themesPointer">
                  <p>Multiple Fed speakers</p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, February 25</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">Australia: </span> CPI releases
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Germany:</span> GDP and consumer climate
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText"> Eurozone:</span> Inflation readings
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Mortgage applications
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">Canada: </span> Manufacturing sales
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">US: </span> 5-year note auction
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Corporate: </span>NVIDIA earnings
                  </p>
                </li>
                <li className="themesPointer">
                  <p>Central bank speakers and policy events</p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, February 26</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">New Zealand:</span> Business confidence
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">Australia: </span>Capital expenditure
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone: </span>Money supply and credit data
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> Initial and continuing jobless claims
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> Kansas City Fed indices
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan: </span> Tokyo CPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> 7-year note auction
                  </p>
                </li>
                <li className="themesPointer">
                  <p>Central bank speakers</p>
                </li>
              </ul>

              <p className="highlightedText">Friday, February 27</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">UK: </span> Consumer confidence
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText"> Eurozone: </span>Inflation prints
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Germany: </span>CPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> PPI and core PPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Canada: </span> GDP
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> Chicago PMI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> Construction spending
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image85}
                    alt="EW 230226"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image85)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image86}
                    alt="US data and speakers"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image86)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Constructive Trend with Competing Narratives</p>
              <p>
                Markets continue to advance within a constructive framework as supportive participation interacts with policy uncertainty and mixed economic signals, reinforcing a backdrop where
                progress and caution coexist.
              </p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities:</span>
                    <br></br> Broad participation and institutional flows support the structure, though leadership rotation and sensitivity to catalysts highlight the importance of monitoring
                    positioning and technical levels.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold & Silver:</span> <br></br> Precious metals remain supported by uncertainty and positioning dynamics, reflecting their role as a hedge amid
                    evolving macro narratives.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span> <br></br>Positioning reflects cautious engagement as markets balance volatility with shifting correlations across asset classes.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span> <br></br> Liquidity dynamics, policy developments, and mixed data continue to frame expectations, reinforcing a balanced
                    environment rather than a clear directional shift.
                  </p>
                </li>
              </ul>

              <p className="highlightedText">
                Markets appear to be navigating a phase where resilience persists alongside ongoing reassessment of risks. Careful monitoring of flows, sentiment, and policy developments remains
                essential as the next phase unfolds.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image24}
                    alt="SPX500 internals are strong"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image24)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image55}
                    alt="record 8 weeks up for gold"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image55)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image1}
                    alt="breadth of SPX performance"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image1)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1S3FE9GHMREvAIQnFVhS0VG8zPYG5QEzwURIqEo4Y3L4/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog57;
